// extracted by mini-css-extract-plugin
export default {"user-extra-details":"UserExtraDetails_user-extra-details__ayG21"};